export const permissions = {
  admin: ['read', 'create', 'update', 'delete', 'analytics'],
  manager: ['read', 'create', 'update', 'analytics'],
  staff: ['read'],
  user: ['read'],
};

export function hasPermission(role: string, action: string) {
  return permissions[role as keyof typeof permissions]?.includes(action);
} 